/* eslint-disable react/prop-types */
import "./index.css";

import React from "react";

const Footer = () => {
    return (
        <footer className="footer">
            &copy; Paweł Śmigielski 2022
        </footer>
    )
}

export default Footer;